export default{
    methods:{
        async getAllTickets(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_all_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllTags(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_all_tags', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllArchiveTags(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/archive/get_all_tags', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getTicektType() {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/ticket_type/list_view')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getDynamicTemplateList(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/dynamic_template/list',params)
                if (response.data.status_id === 1){
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getScmProductsDD(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/scm/get_scm_products_for_tickets',params)
                if (response.data.status_id === 1){
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getProductTemplatesDD(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/scm/get_admin_products_for_tickets',params)
                if (response.data.status_id === 1){
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getDynamicTemplate(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('dynamic_template/get', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getTemplateByDept(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/template/get_templates_for_department',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserForTickets(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/users/get_users_for_tickets',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserForTicketsFilter(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/get_assigned_users',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async deleteSavedFilterById(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/delete',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserForCompanyFilter(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/get_companies',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getOwnerForTicket(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/product_owner_name/list',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async addTicket(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/tickets/add_new_ticket',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async editTemplateTicket(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/tickets/edit_ticket_and_template',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = 'Something went wrong. Please try again.'
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async addSparePart(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/tickets/add_spare_part_template',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getTicketById(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/ticket_management/view_ticket',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    reject(error.response.data.reason)
                    // this.warning_msg = error.response.data.reason
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    // }, 3000);
                }
            })
        },
        async changeStatus(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/ticket_management/change_ticket_status',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getAllActivity(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/activity/get', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserEmails(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/email/get_user_emails', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async deleteTicket(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/archive/move_to_archive',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async templatedForDropdown(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/template/template_for_dropdown',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async filterSave(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/save',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getReplyEmails(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/ticket_management/get_email',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(err){
                    reject(err.response.data.hasOwnProperty('reason') ? err.response.data.reason : err.response.data.message)
                }
            })
        },
        async getActivityById(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/activity/get_activity_by_id',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async checkProductWarranty(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/scm/get_scm_product_warranty_check',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.message)
                }
            })
        },
        async addQuotation(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/tickets/add_quotation',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async editQuotation(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/tickets/edit_quotation',params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch (error) {
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getQuotationDetailsById(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_spare_parts_out_of_warranty',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.message)
                }
            })
        },
        async quotationSendEmail(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/send_quotation_as_an_email',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async replytoEmail(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/email/reply_to_email', params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(err){
                    reject(err.response.data.hasOwnProperty('reason') ? err.response.data.reason : err.response.data.message)
                }
            })
        },
        async getDueDate(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_autofill_data', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getTicketData(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_ticket_data', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async editTicket(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    const response = await this.$http.post('/tickets/edit_ticket_and_template', params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                } catch(error) {
                    console.log(error)
                    reject(error.response.data.reason)
                    // this.$toasted.global.error(error.response.data.reason)
                }
            })
        },
        async addComments(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/comments/add_comment', params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(err) {
                    reject(err.response.data.hasOwnProperty('reason') ? err.response.data.reason : err.response.data.message)
                }
            })
        },
        async getSerial(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/scm/get_scm_serial_number_for_product', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getAllComments(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/comments/get_all_comments', params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(err){
                    reject(err.response.data.hasOwnProperty('reason') ? err.response.data.reason : err.response.data.message)
                }
            })
        },
        async deleteCommentOnly(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await this.$http.post('/comments/delete_comment', params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(err){
                    reject(err.response.data.hasOwnProperty('reason') ? err.response.data.reason : err.response.data.message)
                }
            })
        },
        async getStatusOfTicket(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_status_of_ticket', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getDueDateAndCustomer(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_autofill_data', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async startTimer(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/start_timer', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async stopTimer(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/stop_timer', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Drafts
        async draftSave(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/draft/save', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async draftListView(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/draft/get_all_drafts', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async deleteDraftTicket(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/draft/delete', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getDraftView(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/draft/view', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getDraftData(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    const response = await this.$http.post('/draft/get_draft_data', params)
                    if (response.data.status_id === 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }catch(error){

                }
            })
        },
        async draftUpdate(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/draft/update', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserList(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/users/user_name_list', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getUserListFilter(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/get_users', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Filter API's
        async getAllFilters(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/names', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getFilterById(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/filters/get_view', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getMachineHourHistory(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/get_machine_hour_history', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async setEditDetails(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/set_edit_details', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateTicketWorkFlow(params){
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/tickets/update_ticket_workflow', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getTemplateByJobType(params) {
          return new Promise(async (resolve, reject) => {
            const response = await this.$http.post('/tickets/get_template_name_for_job_type', params)
            if (response.data.status_id === 1) {
                resolve(response.data)
            } else {
                reject(response.data.reason)
            }
        })
        },
        async getTicketTemplates(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/filters/get_all_templates', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getApproversList(params){
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/filters/get_approves', params)
                if(response.data.status_id == 1){
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async sendTicketForReview(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/send_for_review', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async ApproveTicketPart(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/approve_ticket_details', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async ListTicketsToReview(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/filter_review_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async ViewReviewTicket(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/view_review_tickets', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getNextPart(params){
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/get_next_part', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async CloseMultiPartTicket(params){
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/save_ticket_details', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },

        async CloseMultiPartTicket(params){
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/tickets/save_ticket_details', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getschema(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/schema/default_schema_for_dbs')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
    }
}